// !function(a,b,c,d){a.Kustomer=c,c._q=[],c._i=[],c.init=function(a){function b(a,b){a[b]=function(){a._q.push([b].concat(Array.prototype.slice.call(arguments,0)))}}for(var d="init clear identify track start describe on".split(" "),e=0;e<d.length;e++)b(c,d[e]);c._i.push(a)};var e=b.createElement("script");e.type="text/javascript",e.async=!0,e.src="https://cdn.kustomerapp.com/cw/sdk.v1.1.min.js";var f=b.getElementsByTagName("script")[0];f.parentNode.insertBefore(e,f)}(this,document,window.Kustomer||{});

// // Add your API key here
// Kustomer.init('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmMDc5ZjBiZWRiYjkwMDA5NWY0ZmU0YiIsInVzZXIiOiI1ZjA3OWYwYTU0ZmNkMDAwMTU4NzkyZGEiLCJvcmciOiI1ZWQ5MDg4ZmY3ZjhmZDAwMWFmNmM5ZDAiLCJvcmdOYW1lIjoia25vYmJ5IiwidXNlclR5cGUiOiJtYWNoaW5lIiwicG9kIjoicHJvZDEiLCJyb2xlcyI6WyJvcmcuYWRtaW4iXSwiYXVkIjoidXJuOmNvbnN1bWVyIiwiaXNzIjoidXJuOmFwaSIsInN1YiI6IjVmMDc5ZjBhNTRmY2QwMDAxNTg3OTJkYSJ9.4oBFBldleCwwy4FiLwokyEzmyo8mXVRoq0kz6Py_0D8');

// Start the chat client
// Kustomer.start();


var filter = document.querySelectorAll('.collection--filter--main');
if (filter.length > 0) {
  filter[0].addEventListener('click', function() {
    document.getElementById('shopify-section-framework--collection--body').style.minHeight = this.offsetHeight - 150 + 'px';
    document.querySelectorAll('.collection--filter--reset')[0].classList.remove('hidden');
  });
}

if (window.innerWidth > 1399) {
  const el = document.getElementById('shopify-section-framework--collection--body');
  if (el) {
  	document.querySelectorAll('.off-canvas--container')[0].style.top = el.offsetTop + 'px';
  }
}


$(document).on('click', function(e) {
  
  if ($(e.target).attr('class') == 'product-form--text' ) {
    
    const closest = $(e.target).closest('.product-form--container');
    
    const text = $(closest).find(".disclosure--current-option").text().trim();
    
    if ( text == '- SELECT -' ) {
      e.preventDefault();
      
      $(closest).find('.product-form--variants').after('<div id="choose" style="color:var(--color-header-bg)">Please choose a size option</div>');
      
      $('.disclosure--main').css('outline', '2px solid var(--color-header-bg)');
      
      $('.product-form--container').on('click', function() {
        $('#choose').fadeOut();
        $('.disclosure--main').css('outline', 'none');
      });
    }
    
    // Klaviyo tracking
    _learnq.push(['track', 'Added to Cart', item]);
    
  }
   
});

/*
fetch('/cart.js')
  .then(response => response.json())
  .then(data => console.log(data));
*/
/*
function resizeListener() {
  var ymenus = document.getElementsByClassName('y-menu');
  for (var i = 0; i < ymenus.length; i++) {
     ymenus.item(i).style.height=window.innerHeight-200;
  }
}

window.addEventListener("resize", resizeListener);
resizeListener
*/